import React from "react";
import {connect, RootStateOrAny} from 'react-redux'
import {QuestionCircleOutlined} from '@ant-design/icons';
import selectors from "../../../redux/selectors";
import IRoute from "../../../model/interface/dataStorage/IRoute";
import IBaseProps from "../../../model/interface/IBaseProps";
import ManualModal from "../../app/ui/ManualModal";
import Hotkey from "../../shared/hotkey/Hotkey";
import {message} from "antd";
import LocaleText from "../../app/settings/dictionary/LocaleText";

interface IProps extends IBaseProps {
    findOneByUrl: (path: string) => IRoute | null
    getText: (code: string, fallBack?: string) => string
}

interface IState {
    modalVisible: boolean
}

class NavManual extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {
            modalVisible: false
        }
    }

    setModalVisible = () => {
        this.setState(state => ({modalVisible: !state.modalVisible}))
    }

    render() {
        const {getText} = this.props
        const {modalVisible} = this.state
        const route = this.props.findOneByUrl(this.props.history.location.pathname)
        const manual = route ? route.manual : null
        const isManual = !!(manual && route?.manualActive)

        return (
            <>
                {manual && isManual && (
                    <ManualModal id={manual} visible={modalVisible} onFinish={this.setModalVisible}/>
                )}
                <Hotkey
                    helpPlacement={"bottom"}
                    help={isManual ? getText('nav-menu.manual.show', 'Zobrazit manuál') : getText('nav-menu.manual.not-found', 'Žádný manuál pro tuto stránku')}
                    trigger={isManual ? this.setModalVisible : () => message.info(getText('nav-menu.manual.not-found', 'Žádný manuál pro tuto stránku')).then()}
                    keys={['Alt', 'h']}>
                    <QuestionCircleOutlined
                        onClick={() => this.setModalVisible()}
                        disabled={!isManual}
                        className={'nav-icon ' + (isManual ? 'text-primary' : 'text-muted')}
                        style={{fontSize: 21}}
                    />
                </Hotkey>
            </>
        )
    }
}


const mapStateToProps = (state: RootStateOrAny) => {
    return {
        findOneByUrl: (path: string) => selectors.routes.findOneByUrlWithIdentifier(state, path),
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(NavManual)
